import { BidPaymentStatus } from "api";
import cn from "classnames";
import { payableStatuses } from "components/distributionBids/paymentFields";
import { bidPaymentStatuses } from "helpers/enums";
import { paths } from "helpers/paths";
import { enumLabel } from "helpers/system";
import React from "react";
import { Link } from "react-router-dom";

/** Present the confirmed payment status and server overdue flag consistently in both panels. */
export function PaymentStatusBadge({ status, isAccountsPayable, overdue }) {
    const paid = status === BidPaymentStatus.Paid;
    return (
        <span
            className={cn("badge badge-pill settlements__payment-status", {
                "badge-success": paid,
                "badge-danger": !paid && overdue,
                "badge-warning": !paid && !overdue && status === BidPaymentStatus.PartiallyPaid,
                "badge-secondary": !paid && !overdue && status === BidPaymentStatus.NotPaid,
            })}
        >
            {enumLabel(isAccountsPayable ? payableStatuses : bidPaymentStatuses, status)}
        </span>
    );
}

/** Show only the identity and transport details actually returned for the basis. */
export function BasisInfo({ row }) {
    return (
        <div className="settlements__basis-info">
            <Link
                className="settlements__basis-link"
                to={row.isDistributionBid ? paths.distributionBidShow(row.bidId) : paths.bidShow("bid", row.bidId)}
            >
                {row.isDistributionBid ? "Заказ" : "Заявка"} № {row.bidId}
            </Link>
            {row.counterpartyName && <div className="settlements__counterparty mt-1">{row.counterpartyName}</div>}
            {row.legalPersonName && <div className="small text-muted mt-1">{row.legalPersonName}</div>}
            {(row.route || row.carNumber) && (
                <div className="settlements__transport mt-2">
                    {row.route && <div className="small">{row.route}</div>}
                    {row.carNumber && (
                        <span className="carnumber-simple small mt-1 d-inline-block">{row.carNumber}</span>
                    )}
                </div>
            )}
        </div>
    );
}
